import React from 'react'
import { Image, Heading, Text, Flex, Box} from '@pancakeswap/uikit'
import styled, { keyframes } from 'styled-components'
import Page from 'components/Layout/Page'
import { useTranslation } from '@pancakeswap/localization'
import PageHeader from 'components/PageHeader'

const Wrapper = styled.div`
  display: flex;
  justify-content: center;
  padding: 15px;
`

const StyledIframe = styled.iframe`
  --border-radius: 10px;
  box-shadow: 0 2px 10px 0 rgba(0,0,0,.20);
  border-radius: var(--border-radius);
  margin: auto;
  max-width: 420px;
`

const Ramp: React.FC = () => {

  const { t } = useTranslation()

  return (
    <>
      {/* <PageHeader>
        <Heading as="h1" scale="xxl" color="secondary" mb="24px">
          {t('Ramp')}
        </Heading>
      </PageHeader> */}
      <Page>
        <Wrapper>
          <StyledIframe
            src="https://widget.onramper.com?color=266677&apiKey=pk_prod_i9g131xvRdAEsa7sUXcWkgEHEPTCQbUDox7SOZcjKbw0"
            height="660px"
            width="482px"
            title="Onramper widget"
            allow="accelerometer; autoplay; camera; gyroscope; payment"
          >
          </StyledIframe>
        </Wrapper>
      </Page>
    </>
  )
}

export default Ramp
